import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardTitle,
  Table,
} from 'reactstrap';
import { ProperPreSaleVisit } from '../models/dashboardModels';
import {
  IconCalendar,
  IconChevronRight,
  IconClock,
  IconMail,
  IconMapPin,
  IconPhone,
} from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import VisitMarketplaceTypeBadge from '../../../components/VisitMarketplaceTypeBadge';
import { VisitPreSaleState } from '../../../constants/visitsConstants';
import PreSaleFeedbackPill from './PreSaleFeedbackPill';
import InvestorVisitsBadge from '../../../components/badges/InvestorVisitsBadge';

export interface Props {
  visits: ProperPreSaleVisit[];
  footer?: any;
  selectedVisitId?: string | null;
  onSelectVisit?: (visitId: string) => void;
  // Ids de finalizadas sin feedback del Proper (si no se pasa, cada fila lo consulta).
  pendingFeedbackIds?: Set<string>;
}

// Asesorías del Proper: las acciones (marcar como realizada con feedback,
// cancelar) viven en el detalle.
const DashboardPreSaleVisitListTable = ({
  visits,
  footer,
  selectedVisitId,
  onSelectVisit,
  pendingFeedbackIds,
}: Props) => {
  const navigate = useNavigate();

  return (
    <Card className="dv2-table">
      <CardHeader>
        <CardTitle>Asesorias</CardTitle>
      </CardHeader>
      <CardBody>
        <div className="table-responsive">
          <Table striped hover>
            <thead>
              <tr>
                <th>Proyecto</th>
                <th>Inversionista</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {visits.length === 0 && (
                <tr>
                  <td colSpan={4} className="text-center text-muted">
                    No hay asesorías registradas.
                  </td>
                </tr>
              )}
              {visits.map((visit) => (
                <tr
                  key={visit.id}
                  className={visit.id === selectedVisitId ? 'is-selected' : ''}
                  onClick={() => onSelectVisit?.(visit.id)}
                >
                  <td>
                    <div className="font-weight-bold">
                      [{visit.projectInfo.code}] {visit.projectInfo.name}
                    </div>
                    <div className="d-flex align-items-center text-muted small">
                      <IconMapPin size={12} className="me-1" />
                      {visit.projectInfo.address}
                    </div>
                    <div className="text-success font-weight-bold">
                      Unidades desde {visit.projectInfo.range_price}
                    </div>
                    <VisitMarketplaceTypeBadge
                      marketplace_type={visit.visitInfo.marketplace_type}
                    />
                  </td>
                  <td>
                    <div className="font-weight-bold">
                      {visit.visitInfo.investor_name}
                    </div>
                    <div className="d-flex align-items-center text-muted">
                      <IconMail size={12} className="me-1" />{' '}
                      {visit.visitInfo.investor_email}
                    </div>
                    <div className="d-flex align-items-center text-muted">
                      <IconPhone size={12} className="me-1" />
                      {visit.visitInfo.investor_phone}
                    </div>
                    <div className="d-flex align-items-center font-weight-bold">
                      <IconCalendar size={12} className="me-1" />
                      {visit.visitInfo.visit_date}
                    </div>
                    <div className="d-flex align-items-center font-weight-bold">
                      <IconClock size={12} className="me-1" />
                      {visit.visitInfo.visit_time}
                    </div>
                  </td>
                  <td>
                    <InvestorVisitsBadge
                      status={visit.visitInfo.status}
                      className="badge-lg mr-2"
                    />
                    {visit.visitInfo.status === VisitPreSaleState.DONE && (
                      <PreSaleFeedbackPill
                        visitId={visit.id}
                        pending={pendingFeedbackIds?.has(visit.id)}
                      />
                    )}
                  </td>
                  <td>
                    <button
                      type="button"
                      className="dv2-detail-link"
                      onClick={(event) => {
                        event.stopPropagation();
                        navigate(`/dashboard/presale-visits/${visit.id}`, {
                          state: { visit },
                        });
                      }}
                    >
                      Ver detalle
                      <IconChevronRight size={16} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </CardBody>
      <CardFooter>{footer && <div>{footer}</div>}</CardFooter>
    </Card>
  );
};

export default DashboardPreSaleVisitListTable;
